var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 58,
    viewBox: "0 0 41 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(-328 -1561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_12",
    "data-name": "Polygon 12",
    d: "M18.035,1.929a4,4,0,0,1,4.93,0l15.88,12.427a4,4,0,0,1,1.364,4.305L34.028,39.155A4,4,0,0,1,30.2,42H10.8a4,4,0,0,1-3.83-2.845L.79,18.662a4,4,0,0,1,1.364-4.305Z",
    transform: "translate(328 1561)",
    fill: "#d5ecd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_13",
    "data-name": "Polygon 13",
    d: "M18.072,1.855a4,4,0,0,1,4.856,0L38.783,13.967a4,4,0,0,1,1.393,4.36L34.041,38.181A4,4,0,0,1,30.219,41H10.781a4,4,0,0,1-3.822-2.819L.824,18.326a4,4,0,0,1,1.393-4.36Z",
    transform: "translate(328 1570)",
    fill: "#439a63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_14",
    "data-name": "Polygon 14",
    d: "M18.072,1.855a4,4,0,0,1,4.856,0L38.783,13.967a4,4,0,0,1,1.393,4.36L34.041,38.181A4,4,0,0,1,30.219,41H10.781a4,4,0,0,1-3.822-2.819L.824,18.326a4,4,0,0,1,1.393-4.36Z",
    transform: "translate(328 1578)",
    fill: "#08652a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6);
export default __webpack_public_path__ + "static/media/Group6.89e89bc1c9f8412c22e7feb972a313fc.svg";
export { ForwardRef as ReactComponent };